
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12311',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12311",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9679",
  "foundations-components": "static-1.7960",
  "foundations-components-legacy": "static-1.985",
  "foundations-theming": "static-1.4429",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8024",
  "hub-http-shared-msw-handlers": "static-1.9992",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11482",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6475",
  "marketplace-storefront-base": "static-1.12372",
  "quartz": "static-1.7047",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16682",
  "reactive-variable-buffer-atom": "static-1.2869",
  "reporting-testing-lib": "static-1.9536",
  "settings-ui-lib": "static-1.12531",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7159",
  "ui-addon-i18n": "static-1.11159",
  "ui-addon-react-router-dom": "static-1.9552",
  "unified-auth": "static-1.505",
  "unified-auth-core-lib": "static-1.787",
  "usage-tracker": "static-1.7354",
  "usage-tracker-core": "static-1.7204",
  "customer-data-property-utils": "static-1.8101",
  "hub-http": "static-1.6232",
  "integrations-lib": "static-1.16188",
  "marketplace-ui-common": "static-1.19757",
  "property-management-iframe": "static-1.13197",
  "quartz-config": "static-1.825",
  "quartz-core": "static-1.6266",
  "quartz-routing": "static-1.477",
  "quick-fetch": "static-1.3923",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4663",
  "ts-schema": "static-1.4086",
  "ui-universal-auth": "static-1.8991",
  "UIComponents": "static-3.8428",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3324",
  "quartz-webpack": "static-1.3271",
  "bend-plugin-quartz-routing": "static-1.125",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4229",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4877",
  "foundations-theming-specialty": "static-1.2145",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9435",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5351",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1978",
  "ui-fonts": "static-1.744",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-theming": "static-1.2912",
  "foundations-theming-base": "static-1.3414",
  "stylex": "static-1.33",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3135",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4338",
  "ai-components-ui-library": "static-1.9014",
  "ai-rendering-library": "static-1.10220",
  "chirp-fetch": "static-1.1898",
  "connections-embed-lib": "static-1.1011",
  "copilot-toolkit": "static-1.11167",
  "feedback-loader": "static-1.29315",
  "laboratory-lib": "static-3.7166",
  "marketplace-embed": "static-1.22128",
  "marketplace-ui-details": "static-1.9653",
  "marketplace-ui-reviews": "static-1.19713",
  "marketplace-ui-tracking": "static-1.13928",
  "sanitize-text": "static-1.8152",
  "ui-addon-video-player": "static-1.8713",
  "usage-tracker-multi": "static-1.5768",
  "usage-tracker-session-replay": "static-1.5040",
  "wootric-nps": "static-1.6985",
  "quartz-head": "static-1.712",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4662",
  "immer": "static-1.33",
  "immerable": "static-1.4165",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67603",
  "cssUtils": "static-1.794",
  "flux-actions": "static-1.338",
  "HubStyle": "static-2.11789",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10217",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10376",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7344",
  "icons": "static-2.648",
  "marketplace-ui-apps-core": "static-1.18290",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4526",
  "foundations-components-test-utils": "static-1.5443",
  "quartz-i18n": "static-1.722",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.277",
  "microsoft-drive-integration-lib": "static-1.396",
  "slack-ui-library": "static-1.10403",
  "fsm": "static-1.3741",
  "customer-data-objects": "static-1.7680",
  "property-translator": "static-1.5411",
  "hs-locale-management": "static-1.87",
  "frontend-preferences-client": "static-1.7938",
  "hs-promise-utils": "static-1.5602",
  "hubspot-apollo-client": "static-1.4890",
  "integrations-error-boundary-lib": "static-1.13603",
  "integrations-tracking-lib": "static-1.5611",
  "native-integrations-shared-strings": "static-1.7792",
  "reselect": "static-2.16",
  "sanitize": "static-1.4487",
  "superstore": "static-1.4772",
  "ui-shepherd-react": "static-3.10175",
  "ai-settings-ui-library": "static-1.7903",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4658",
  "immutable-less": "static-1.4664",
  "marketplace-ui-client-types": "static-1.17164",
  "nav-meta": "static-1.29711",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10258",
  "ui-addon-upgrades": "static-9.18011",
  "inbound-db-properties-service-client": "static-1.3852",
  "property-management-common": "static-1.5485",
  "ui-addon-iframeable": "static-1.9068",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.722",
  "quartz-test": "static-1.722",
  "quartz-tracking": "static-1.426",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.73",
  "bender-build-tools": "static-1.3205",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21389",
  "ContentUtils": "static-1.68404",
  "customer-data-objects-ui-components": "static-1.13038",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.59",
  "avatar-components": "static-1.2507",
  "customer-data-filters-ui": "static-1.39834",
  "customer-data-reference-ui-components": "static-1.13175",
  "embedded-academy-lib": "static-1.14385",
  "ExportDialog": "static-6.10399",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41339",
  "reporting-snowflake": "static-1.56221",
  "reporting-ui-components": "static-2.64874",
  "reporting-visualizations": "static-1.59679",
  "ui-addon-teams": "static-1.21569",
  "magpie-lib": "static-1.5558",
  "navigation-components": "static-1.18074",
  "magpie-types": "static-1.5018",
  "simple-logging-lib": "static-1.3061",
  "ai-studio-lib": "static-1.11653",
  "app-governance-lib": "static-1.1579",
  "developer-experience-shared-components": "static-1.10520",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8009",
  "ui-product-approvals": "static-1.28160",
  "ui-tool-access": "static-1.10158",
  "usage-based-billing-components-lib": "static-1.8949",
  "usage-tracker-anonymous": "static-1.5771",
  "usage-tracker-public": "static-1.7165",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3592",
  "persist-promise": "static-1.3709",
  "reference-resolvers": "static-1.8181",
  "ui-extensibility-client-types": "static-1.3934",
  "hubspot-apollo-cache": "static-1.349",
  "universal-page-editor-lib": "static-1.3023",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2818",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5083",
  "purchase-motions-components": "static-1.5925",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1552",
  "crm-component-utils": "static-1.39113",
  "crm-properties-common-lib": "static-1.5895",
  "customer-data-properties": "static-1.51593",
  "framework-data-schema-resolvers": "static-1.6895",
  "property-value-citations": "static-1.2207",
  "reference-resolvers-lite": "static-1.8105",
  "ui-business-units-lib": "static-1.9065",
  "navigation-messaging": "static-1.7401",
  "hubspotter-http-shared-msw-handlers": "static-1.9990",
  "cms-field-types": "static-1.4823",
  "content-icons-ui": "static-1.2229",
  "customer-data-ui-utilities": "static-1.9837",
  "events-data-lib": "static-1.232",
  "conversations-skeleton-state": "static-1.7257",
  "crm-message-bus": "static-1.43029",
  "customer-data-filters-ui-msw-helpers": "static-1.22269",
  "FormUrlGenerator": "static-2.4729",
  "framework-builder-read-service-client": "static-1.4011",
  "framework-data-schema-quick-fetch": "static-1.6800",
  "multi-account-reference-resolvers": "static-1.990",
  "onboarding-tours": "static-1.16633",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13722",
  "academy-common-lib": "static-1.13845",
  "content-assistance-lib": "static-1.7769",
  "dashboard-lib": "static-1.81580",
  "file-manager-components": "static-1.23660",
  "getting-started-shared-tasks": "static-1.18501",
  "hubspot-prosemirror": "static-1.18268",
  "hubspot-prosemirror-plugins": "static-1.18260",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19855",
  "share-with-third-party-component-lib": "static-1.8712",
  "ui-addon-draggable": "static-3.4773",
  "ui-asset-management-lib": "static-1.11049",
  "user-context": "static-1.5116",
  "growth-payments-core": "static-1.25418",
  "reporting-plugins": "static-1.10341",
  "reporting-reports": "static-1.67281",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.735",
  "nest": "static-1.237",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10637",
  "framework-listing-lib": "static-2.28745",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30745",
  "apps-service-types": "static-1.3888",
  "oauth-service-types": "static-1.4259",
  "ui-product-approvals-common": "static-1.55",
  "onboarding-scopes": "static-1.6472",
  "onboarding-tours-client": "static-1.4847",
  "platform-infra-nav-components": "static-1.7676",
  "subscription-experience-data-types": "static-1.14949",
  "crm-record-cards-service-types": "static-1.3603",
  "location-customization-utils-lib": "static-1.9301",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5928",
  "signup-constants": "static-1.18859",
  "signup-ui-url-generator": "static-2.8061",
  "trials-service-types": "static-1.3913",
  "card-properties-lib": "static-1.44235",
  "commerce-subscription-lib": "static-1.37159",
  "crm-actions": "static-1.6336",
  "crm-cards-sdk": "static-1.43627",
  "customer-data-properties-shared-msw-handlers": "static-1.9319",
  "customer-data-tracking": "static-1.6900",
  "hs-resources": "static-1.162",
  "pulse": "static-1.585",
  "calling-global-api": "static-1.64552",
  "calling-internal-common": "static-1.31313",
  "calling-lifecycle-internal": "static-1.65934",
  "calling-lifecycle-messages": "static-1.58228",
  "commerce-products-lib": "static-1.9613",
  "conditional-properties-service-client": "static-1.3803",
  "crm-links": "static-1.6304",
  "external-options-client-types": "static-1.4165",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4229",
  "meetings-icalendar-utils-lib": "static-1.642",
  "multi-currency-client-types": "static-1.3697",
  "object-builder-ui-client": "static-1.48788",
  "pipeline-validation-client-types": "static-1.3971",
  "smart-property-lib": "static-1.7132",
  "tiered-pricing": "static-1.1244",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11000",
  "crm-pipelines-api-client-types": "static-1.4145",
  "fdsr-migration-layer": "static-1.14",
  "react-dnd-compat": "static-1.4625",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.915",
  "growth-data-modal": "static-1.5446",
  "growth-onboarding-confetti": "static-1.3077",
  "growth-onboarding-next-action-utils": "static-1.1959",
  "onboarding-tours-utils": "static-1.699",
  "ui-shepherd-tracker": "static-1.7556",
  "academy-service-client": "static-1.3691",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39159",
  "FileManagerLib": "static-1.39300",
  "video-embed": "static-1.35807",
  "ui-coaching-tips": "static-1.28596",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11315",
  "video-data-lib": "static-1.34973",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23577",
  "ui-addon-emoji-picker": "static-1.9898",
  "EmailSignatureEditor": "static-1.24397",
  "viral-links-lib": "static-1.7074",
  "data-token-picker": "static-1.16429",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.237",
  "timezone-utils": "static-2.5255",
  "seat-types-lib": "static-1.39",
  "getting-started-shared-tasks-store": "static-1.17619",
  "ui-addon-opt": "static-4.8377",
  "campaign-roi-lib": "static-1.9160",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7336",
  "customer-data-views-management": "static-1.25484",
  "framework-data-table": "static-2.11943",
  "marketing-platform-lib": "static-1.6868",
  "nudge-client-utils": "static-1.2606",
  "nudge-custom-ui-functions": "static-1.1042",
  "app-users-service-client": "static-1.5608",
  "app-users-service-types": "static-1.5016",
  "mini-checkout-client": "static-1.26839",
  "onboarding-utils": "static-1.5364",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28581",
  "edison-service-client-types": "static-1.398",
  "crm_data": "static-4.92007",
  "customer-data-sidebar": "static-2.46055",
  "enrichment-properties-lib": "static-1.16250",
  "ui-addon-draggable-compat": "static-2.4267",
  "commerce-billing-lib": "static-1.19111",
  "commerce-shared-components-lib": "static-1.18574",
  "commerce-tools-ui-lib": "static-1.10410",
  "crm-fe-perf": "static-1.22913",
  "bend-plugin-pulse": "static-1.88",
  "directed-graph": "static-1.946",
  "event-emitter": "static-1.958",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31320",
  "shared-worker-versioning": "static-1.11047",
  "calling-usage-tracker": "static-1.6552",
  "voice-sms-access-library": "static-1.1016",
  "commerce-permissions": "static-1.780",
  "products-iframe-lib": "static-1.7973",
  "products-ui-components-shared-msw-handlers": "static-1.10374",
  "data-agent-kit": "static-1.211",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10075",
  "policy-lib": "static-1.6788",
  "react-tinymce": "static-1.55280",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10138",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54406",
  "tinymce-plugins": "static-1.57520",
  "tinymce-themes": "static-1.56376",
  "onboarding-data-sync-lib": "static-1.1975",
  "growth-onboarding-next-action-components": "static-1.1987",
  "user-context-client": "static-1.4623",
  "audio-components": "static-1.5931",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36811",
  "urlinator": "static-1.4547",
  "video-components": "static-1.13318",
  "outpost": "static-1.4192",
  "growth-onboarding-feedback-components": "static-1.6591",
  "content-media-composition-data-lib": "static-1.12360",
  "content-media-compositions": "static-2.16367",
  "media-bridge-lib": "static-1.18948",
  "commerce-tours-lib": "static-1.6123",
  "growth-onboarding-reliability": "static-1.5093",
  "sales-checkout-service-client": "static-1.3651",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21698",
  "sales-email-signature-service-client": "static-1.3853",
  "ts-utils-lib": "static-1.183",
  "breeze-engine-lib": "static-1.691",
  "crm-export-dialog": "static-1.6304",
  "crm-index-associations-lib": "static-1.6451",
  "crm-view-components": "static-1.295",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2363",
  "nudge-renderer-utils": "static-1.2682",
  "whisper-core-api": "static-1.6659",
  "InboxConnectUtils": "static-4.14850",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5580",
  "settings-content-modals": "static-1.46121",
  "crm_universal": "static-1.22029",
  "customer-data-email": "static-1.18056",
  "card-payment-highlight-lib": "static-1.37214",
  "card-subscription-highlight-lib": "static-1.39582",
  "commerce-contract-lib": "static-1.12103",
  "invoices-highlight-card-lib": "static-1.54770",
  "orders-highlight-card-lib": "static-1.21508",
  "products-highlight-card-lib": "static-1.17896",
  "quotes-highlight-card-lib": "static-1.72087",
  "crm-source-interpretation-lib": "static-1.5353",
  "utility-belt": "static-1.2545",
  "payments-enrollment-embed-lib": "static-1.22935",
  "stripe-embedded-components": "static-1.7527",
  "customer-data-rte": "static-1.33031",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5751",
  "payments-post-enroll-local-storage-lib": "static-1.5119",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38177",
  "calling-orchestration-schema": "static-1.35793",
  "sales-views-client-types": "static-1.4269",
  "hub-http-contrib": "static-1.3053",
  "interframe": "static-3.4770",
  "tinymce-data": "static-1.40491",
  "ui-addon-sales-email": "static-1.5221",
  "layout-dnd-components": "static-1.12468",
  "layout-dnd-utils": "static-1.11443",
  "ui-brand-identity-lib": "static-1.15322",
  "NamespacedHubStyle": "static-2.9065",
  "meetings-connect-utils-lib": "static-1.7616",
  "social-insights-client-types": "static-1.22151",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4151",
  "checkout-sdk": "static-3.23682",
  "checkout-service-types": "static-1.3827",
  "company-details-components": "static-1.6206",
  "payment-method-components": "static-1.6917",
  "pricing-pages-ui-components": "static-1.14061",
  "quote-checkout-service-types": "static-1.3477",
  "upgrade-catalog-service-types": "static-1.3530",
  "access-control-lib": "static-1.10446",
  "EmailComponents": "static-1.54784",
  "EmailData": "static-1.53461",
  "redux-less": "static-2.9494",
  "sequences-lib": "static-1.8063",
  "ui-gdpr-components": "static-1.10361",
  "products-ui-components": "static-1.40131",
  "accounting-integrations-ui-components": "static-1.7084",
  "invoices-ui-lib": "static-1.54786",
  "commerce-products-api": "static-1.2312",
  "invoices-iframe-lib": "static-1.56844",
  "quotes-modal-lib": "static-1.102765",
  "quotes-ui-lib": "static-1.80808",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28303",
  "ContentData": "static-1.68479",
  "layout-data-lib": "static-1.9768",
  "hub-http-rxjs": "static-1.802",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3949",
  "billing-payments-client-types": "static-1.3999",
  "react-performance-metrics-lib": "static-1.566",
  "account-and-billing-fintech-outages": "static-3.18603",
  "pricing-pages-api": "static-1.13926",
  "ContentComponents": "static-2.71360",
  "marketing-contacts-lib": "static-1.10087",
  "marketing-email-service-types": "static-1.1919",
  "messaging-editing-lib": "static-1.46313",
  "messaging-usage-based-billing-components-lib": "static-1.1175",
  "automation-ui-source-apps": "static-1.18930",
  "automation-ui-types": "static-1.19848",
  "messaging-types-lib": "static-1.46050",
  "onboarding-settings-client": "static-1.4515",
  "sequences-client-types-lib": "static-1.7920",
  "commerce-tax-lib": "static-1.537",
  "price-books-api": "static-1.786",
  "price-books-components": "static-1.844",
  "property-description-translator": "static-1.3855",
  "ramp-editor": "static-1.178",
  "commerce-analytics-service-client": "static-1.3639",
  "totals-ui-components": "static-1.23637",
  "SalesContentIndexUI": "static-3.9266",
  "advanced-menus-core": "static-1.15145",
  "advanced-menus-lib": "static-1.12084",
  "ui-memberships-settings-lib": "static-1.34082",
  "segments-query-core": "static-1.1429",
  "demographics-service-types": "static-1.1662",
  "eligibility-engine-service-types": "static-1.3194",
  "automation-ui-ubb": "static-1.5764",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7349",
  "data-token-views": "static-1.16410",
  "forms-utils-lib": "static-1.12607",
  "payments-embed-points-lib": "static-1.13061",
  "simple-menus-core": "static-1.15144",
  "simple-menus-lib": "static-1.16661",
  "videoconference-integration-components": "static-1.6836",
  "marketing-contacts-client": "static-1.7528",
  "automation-applications-service-types": "static-1.3518",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77158",
  "short-messages-app-service-client": "static-1.3978",
  "web-interactives-components": "static-1.13781",
  "web-interactives-data": "static-1.13782",
  "messaging-shared-utils-lib": "static-1.624",
  "messaging-user-info-utils-lib": "static-1.794",
  "email-portal-health-service-types": "static-1.988",
  "line-items-api": "static-1.712",
  "commerce-totals-service-types": "static-1.3825",
  "FireAlarmUi": "static-1.4519",
  "sales-templates-service-types-lib": "static-1.4176",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21784",
  "automation-ui-usage-tracking": "static-1.21247",
  "data-studio-ubb": "static-1.2766",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27059",
  "collaboration-sidebar": "static-1.57856",
  "content-management-data-lib": "static-1.5400",
  "copilot-plugins": "static-1.11140",
  "cta-picker": "static-1.36438",
  "customer-agent-discovery-components-lib": "static-1.3121",
  "editor-components": "static-1.13243",
  "editor-iframe-lib": "static-1.8417",
  "error-messaging-js": "static-1.5203",
  "FormsCommonComponents": "static-1.85888",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10656",
  "SharedLegalStrings": "static-1.1758",
  "smart-content-core": "static-1.42480",
  "smart-content-lib": "static-1.43133",
  "social-composer-lib": "static-1.59194",
  "structured-content-lib": "static-1.25228",
  "theme-previewer-lib": "static-1.53293",
  "tinymce-copilot": "static-1.16474",
  "xray-recommendation-lib": "static-1.7921",
  "automation-ui-routing": "static-1.21205",
  "sql-reporting-client-types": "static-1.5650",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42227",
  "campaigns-utils-lib": "static-1.3190",
  "reporting-enablement": "static-1.22972",
  "chatspot-widget-iframe": "static-1.21380",
  "collaboration-sidebar-common": "static-1.2653",
  "forms-ai-lib": "static-1.4336",
  "codemirror-dlb": "static-1.58717",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6442",
  "report-customization-components": "static-1.13209",
  "data-quality-ui-library": "static-1.13069",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.358",
  "reporting-insights-lib": "static-1.1788"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12311",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9679",
  "foundations-components": "/foundations-components/static-1.7960",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.985",
  "foundations-theming": "/foundations-theming/static-1.4429",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8024",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9992",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11482",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6475",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12372",
  "quartz": "/quartz/static-1.7047",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16682",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2869",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9536",
  "settings-ui-lib": "/settings-ui-lib/static-1.12531",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7159",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11159",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9552",
  "unified-auth": "/unified-auth/static-1.505",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.787",
  "usage-tracker": "/usage-tracker/static-1.7354",
  "usage-tracker-core": "/usage-tracker-core/static-1.7204",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8101",
  "hub-http": "/hub-http/static-1.6232",
  "integrations-lib": "/integrations-lib/static-1.16188",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19757",
  "property-management-iframe": "/property-management-iframe/static-1.13197",
  "quartz-config": "/quartz-config/static-1.825",
  "quartz-core": "/quartz-core/static-1.6266",
  "quartz-routing": "/quartz-routing/static-1.477",
  "quick-fetch": "/quick-fetch/static-1.3923",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4663",
  "ts-schema": "/ts-schema/static-1.4086",
  "ui-universal-auth": "/ui-universal-auth/static-1.8991",
  "UIComponents": "/UIComponents/static-3.8428",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3324",
  "quartz-webpack": "/quartz-webpack/static-1.3271",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.125",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4229",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4877",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2145",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9435",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5351",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1978",
  "ui-fonts": "/ui-fonts/static-1.744",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2912",
  "foundations-theming-base": "/foundations-theming-base/static-1.3414",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3135",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4338",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9014",
  "ai-rendering-library": "/ai-rendering-library/static-1.10220",
  "chirp-fetch": "/chirp-fetch/static-1.1898",
  "connections-embed-lib": "/connections-embed-lib/static-1.1011",
  "copilot-toolkit": "/copilot-toolkit/static-1.11167",
  "feedback-loader": "/feedback-loader/static-1.29315",
  "laboratory-lib": "/laboratory-lib/static-3.7166",
  "marketplace-embed": "/marketplace-embed/static-1.22128",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9653",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19713",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13928",
  "sanitize-text": "/sanitize-text/static-1.8152",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8713",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5768",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5040",
  "wootric-nps": "/wootric-nps/static-1.6985",
  "quartz-head": "/quartz-head/static-1.712",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4662",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4165",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67603",
  "cssUtils": "/cssUtils/static-1.794",
  "flux-actions": "/flux-actions/static-1.338",
  "HubStyle": "/HubStyle/static-2.11789",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10217",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10376",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7344",
  "icons": "/icons/static-2.648",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18290",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4526",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5443",
  "quartz-i18n": "/quartz-i18n/static-1.722",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.277",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.396",
  "slack-ui-library": "/slack-ui-library/static-1.10403",
  "fsm": "/fsm/static-1.3741",
  "customer-data-objects": "/customer-data-objects/static-1.7680",
  "property-translator": "/property-translator/static-1.5411",
  "hs-locale-management": "/hs-locale-management/static-1.87",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7938",
  "hs-promise-utils": "/hs-promise-utils/static-1.5602",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4890",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13603",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5611",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7792",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4487",
  "superstore": "/superstore/static-1.4772",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10175",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7903",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4658",
  "immutable-less": "/immutable-less/static-1.4664",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17164",
  "nav-meta": "/nav-meta/static-1.29711",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10258",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18011",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3852",
  "property-management-common": "/property-management-common/static-1.5485",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9068",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.722",
  "quartz-test": "/quartz-test/static-1.722",
  "quartz-tracking": "/quartz-tracking/static-1.426",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.73",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21389",
  "ContentUtils": "/ContentUtils/static-1.68404",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13038",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.59",
  "avatar-components": "/avatar-components/static-1.2507",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39834",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13175",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14385",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41339",
  "reporting-snowflake": "/reporting-snowflake/static-1.56221",
  "reporting-ui-components": "/reporting-ui-components/static-2.64874",
  "reporting-visualizations": "/reporting-visualizations/static-1.59679",
  "ui-addon-teams": "/ui-addon-teams/static-1.21569",
  "magpie-lib": "/magpie-lib/static-1.5558",
  "navigation-components": "/navigation-components/static-1.18074",
  "magpie-types": "/magpie-types/static-1.5018",
  "simple-logging-lib": "/simple-logging-lib/static-1.3061",
  "ai-studio-lib": "/ai-studio-lib/static-1.11653",
  "app-governance-lib": "/app-governance-lib/static-1.1579",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10520",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8009",
  "ui-product-approvals": "/ui-product-approvals/static-1.28160",
  "ui-tool-access": "/ui-tool-access/static-1.10158",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8949",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5771",
  "usage-tracker-public": "/usage-tracker-public/static-1.7165",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3592",
  "persist-promise": "/persist-promise/static-1.3709",
  "reference-resolvers": "/reference-resolvers/static-1.8181",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3934",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.349",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3023",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2818",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5083",
  "purchase-motions-components": "/purchase-motions-components/static-1.5925",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1552",
  "crm-component-utils": "/crm-component-utils/static-1.39113",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5895",
  "customer-data-properties": "/customer-data-properties/static-1.51593",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6895",
  "property-value-citations": "/property-value-citations/static-1.2207",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8105",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9065",
  "navigation-messaging": "/navigation-messaging/static-1.7401",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9990",
  "cms-field-types": "/cms-field-types/static-1.4823",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9837",
  "events-data-lib": "/events-data-lib/static-1.232",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7257",
  "crm-message-bus": "/crm-message-bus/static-1.43029",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22269",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4729",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4011",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6800",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.990",
  "onboarding-tours": "/onboarding-tours/static-1.16633",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13722",
  "academy-common-lib": "/academy-common-lib/static-1.13845",
  "content-assistance-lib": "/content-assistance-lib/static-1.7769",
  "dashboard-lib": "/dashboard-lib/static-1.81580",
  "file-manager-components": "/file-manager-components/static-1.23660",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18501",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18268",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18260",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19855",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8712",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4773",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11049",
  "user-context": "/user-context/static-1.5116",
  "growth-payments-core": "/growth-payments-core/static-1.25418",
  "reporting-plugins": "/reporting-plugins/static-1.10341",
  "reporting-reports": "/reporting-reports/static-1.67281",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.735",
  "nest": "/nest/static-1.237",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10637",
  "framework-listing-lib": "/framework-listing-lib/static-2.28745",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30745",
  "apps-service-types": "/apps-service-types/static-1.3888",
  "oauth-service-types": "/oauth-service-types/static-1.4259",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.55",
  "onboarding-scopes": "/onboarding-scopes/static-1.6472",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4847",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7676",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14949",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3603",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9301",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5928",
  "signup-constants": "/signup-constants/static-1.18859",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8061",
  "trials-service-types": "/trials-service-types/static-1.3913",
  "card-properties-lib": "/card-properties-lib/static-1.44235",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37159",
  "crm-actions": "/crm-actions/static-1.6336",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43627",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9319",
  "customer-data-tracking": "/customer-data-tracking/static-1.6900",
  "hs-resources": "/hs-resources/static-1.162",
  "pulse": "/pulse/static-1.585",
  "calling-global-api": "/calling-global-api/static-1.64552",
  "calling-internal-common": "/calling-internal-common/static-1.31313",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65934",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58228",
  "commerce-products-lib": "/commerce-products-lib/static-1.9613",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3803",
  "crm-links": "/crm-links/static-1.6304",
  "external-options-client-types": "/external-options-client-types/static-1.4165",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4229",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.642",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3697",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48788",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3971",
  "smart-property-lib": "/smart-property-lib/static-1.7132",
  "tiered-pricing": "/tiered-pricing/static-1.1244",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11000",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4145",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.14",
  "react-dnd-compat": "/react-dnd-compat/static-1.4625",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.915",
  "growth-data-modal": "/growth-data-modal/static-1.5446",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3077",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1959",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.699",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7556",
  "academy-service-client": "/academy-service-client/static-1.3691",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39159",
  "FileManagerLib": "/FileManagerLib/static-1.39300",
  "video-embed": "/video-embed/static-1.35807",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28596",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11315",
  "video-data-lib": "/video-data-lib/static-1.34973",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23577",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9898",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24397",
  "viral-links-lib": "/viral-links-lib/static-1.7074",
  "data-token-picker": "/data-token-picker/static-1.16429",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.237",
  "timezone-utils": "/timezone-utils/static-2.5255",
  "seat-types-lib": "/seat-types-lib/static-1.39",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17619",
  "ui-addon-opt": "/ui-addon-opt/static-4.8377",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9160",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7336",
  "customer-data-views-management": "/customer-data-views-management/static-1.25484",
  "framework-data-table": "/framework-data-table/static-2.11943",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6868",
  "nudge-client-utils": "/nudge-client-utils/static-1.2606",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1042",
  "app-users-service-client": "/app-users-service-client/static-1.5608",
  "app-users-service-types": "/app-users-service-types/static-1.5016",
  "mini-checkout-client": "/mini-checkout-client/static-1.26839",
  "onboarding-utils": "/onboarding-utils/static-1.5364",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28581",
  "edison-service-client-types": "/edison-service-client-types/static-1.398",
  "crm_data": "/crm_data/static-4.92007",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46055",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16250",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4267",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19111",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18574",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10410",
  "crm-fe-perf": "/crm-fe-perf/static-1.22913",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.88",
  "directed-graph": "/directed-graph/static-1.946",
  "event-emitter": "/event-emitter/static-1.958",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31320",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11047",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6552",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1016",
  "commerce-permissions": "/commerce-permissions/static-1.780",
  "products-iframe-lib": "/products-iframe-lib/static-1.7973",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10374",
  "data-agent-kit": "/data-agent-kit/static-1.211",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10075",
  "policy-lib": "/policy-lib/static-1.6788",
  "react-tinymce": "/react-tinymce/static-1.55280",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10138",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54406",
  "tinymce-plugins": "/tinymce-plugins/static-1.57520",
  "tinymce-themes": "/tinymce-themes/static-1.56376",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1975",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1987",
  "user-context-client": "/user-context-client/static-1.4623",
  "audio-components": "/audio-components/static-1.5931",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36811",
  "urlinator": "/urlinator/static-1.4547",
  "video-components": "/video-components/static-1.13318",
  "outpost": "/outpost/static-1.4192",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6591",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12360",
  "content-media-compositions": "/content-media-compositions/static-2.16367",
  "media-bridge-lib": "/media-bridge-lib/static-1.18948",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6123",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5093",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3651",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21698",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3853",
  "ts-utils-lib": "/ts-utils-lib/static-1.183",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.691",
  "crm-export-dialog": "/crm-export-dialog/static-1.6304",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6451",
  "crm-view-components": "/crm-view-components/static-1.295",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2363",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2682",
  "whisper-core-api": "/whisper-core-api/static-1.6659",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14850",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5580",
  "settings-content-modals": "/settings-content-modals/static-1.46121",
  "crm_universal": "/crm_universal/static-1.22029",
  "customer-data-email": "/customer-data-email/static-1.18056",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37214",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39582",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12103",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54770",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21508",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17896",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72087",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5353",
  "utility-belt": "/utility-belt/static-1.2545",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22935",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7527",
  "customer-data-rte": "/customer-data-rte/static-1.33031",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5751",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5119",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38177",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35793",
  "sales-views-client-types": "/sales-views-client-types/static-1.4269",
  "hub-http-contrib": "/hub-http-contrib/static-1.3053",
  "interframe": "/interframe/static-3.4770",
  "tinymce-data": "/tinymce-data/static-1.40491",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5221",
  "layout-dnd-components": "/layout-dnd-components/static-1.12468",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11443",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15322",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9065",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7616",
  "social-insights-client-types": "/social-insights-client-types/static-1.22151",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4151",
  "checkout-sdk": "/checkout-sdk/static-3.23682",
  "checkout-service-types": "/checkout-service-types/static-1.3827",
  "company-details-components": "/company-details-components/static-1.6206",
  "payment-method-components": "/payment-method-components/static-1.6917",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14061",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3477",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3530",
  "access-control-lib": "/access-control-lib/static-1.10446",
  "EmailComponents": "/EmailComponents/static-1.54784",
  "EmailData": "/EmailData/static-1.53461",
  "redux-less": "/redux-less/static-2.9494",
  "sequences-lib": "/sequences-lib/static-1.8063",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10361",
  "products-ui-components": "/products-ui-components/static-1.40131",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7084",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54786",
  "commerce-products-api": "/commerce-products-api/static-1.2312",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56844",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102765",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80808",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28303",
  "ContentData": "/ContentData/static-1.68479",
  "layout-data-lib": "/layout-data-lib/static-1.9768",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.802",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3949",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3999",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.566",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18603",
  "pricing-pages-api": "/pricing-pages-api/static-1.13926",
  "ContentComponents": "/ContentComponents/static-2.71360",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10087",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46313",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1175",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18930",
  "automation-ui-types": "/automation-ui-types/static-1.19848",
  "messaging-types-lib": "/messaging-types-lib/static-1.46050",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4515",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7920",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.537",
  "price-books-api": "/price-books-api/static-1.786",
  "price-books-components": "/price-books-components/static-1.844",
  "property-description-translator": "/property-description-translator/static-1.3855",
  "ramp-editor": "/ramp-editor/static-1.178",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3639",
  "totals-ui-components": "/totals-ui-components/static-1.23637",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9266",
  "advanced-menus-core": "/advanced-menus-core/static-1.15145",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12084",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34082",
  "segments-query-core": "/segments-query-core/static-1.1429",
  "demographics-service-types": "/demographics-service-types/static-1.1662",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3194",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5764",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7349",
  "data-token-views": "/data-token-views/static-1.16410",
  "forms-utils-lib": "/forms-utils-lib/static-1.12607",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13061",
  "simple-menus-core": "/simple-menus-core/static-1.15144",
  "simple-menus-lib": "/simple-menus-lib/static-1.16661",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6836",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7528",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3518",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77158",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3978",
  "web-interactives-components": "/web-interactives-components/static-1.13781",
  "web-interactives-data": "/web-interactives-data/static-1.13782",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.624",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.794",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.988",
  "line-items-api": "/line-items-api/static-1.712",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3825",
  "FireAlarmUi": "/FireAlarmUi/static-1.4519",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4176",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21784",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21247",
  "data-studio-ubb": "/data-studio-ubb/static-1.2766",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27059",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57856",
  "content-management-data-lib": "/content-management-data-lib/static-1.5400",
  "copilot-plugins": "/copilot-plugins/static-1.11140",
  "cta-picker": "/cta-picker/static-1.36438",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3121",
  "editor-components": "/editor-components/static-1.13243",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8417",
  "error-messaging-js": "/error-messaging-js/static-1.5203",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85888",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10656",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1758",
  "smart-content-core": "/smart-content-core/static-1.42480",
  "smart-content-lib": "/smart-content-lib/static-1.43133",
  "social-composer-lib": "/social-composer-lib/static-1.59194",
  "structured-content-lib": "/structured-content-lib/static-1.25228",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53293",
  "tinymce-copilot": "/tinymce-copilot/static-1.16474",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7921",
  "automation-ui-routing": "/automation-ui-routing/static-1.21205",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5650",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42227",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3190",
  "reporting-enablement": "/reporting-enablement/static-1.22972",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21380",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2653",
  "forms-ai-lib": "/forms-ai-lib/static-1.4336",
  "codemirror-dlb": "/codemirror-dlb/static-1.58717",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6442",
  "report-customization-components": "/report-customization-components/static-1.13209",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13069",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.358",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1788"
}
};
